import PropTypes from "prop-types";
import {useState} from "react";
import {greyishBlue50} from "assets/jss/main";
import OptionValueSelect from "./OptionValueSelect";

MappingValueLine.propTypes = {
    row: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        sku: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        optionValue: PropTypes.string.isRequired,
        lang: PropTypes.string,
    }).isRequired,
    checked: PropTypes.bool,
    isLast: PropTypes.bool,
    onCheck: PropTypes.func,
    onOptionValueChange: PropTypes.func,
    onValidate: PropTypes.func,
    onEdit: PropTypes.func,
};

function CheckIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );
}

function PenIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="2" x2="22" y2="6" />
            <path d="M7.5 20.5L19 9l-4-4L3.5 16.5 2 22z" />
        </svg>
    );
}

function MappingValueLine({
    row,
    checked = false,
    isLast = false,
    onCheck = () => {},
    onOptionValueChange = () => {},
    onValidate = () => {},
    onEdit = () => {},
}) {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                padding: "16px 20px",
                borderBottom: isLast ? "none" : `1px solid ${greyishBlue50}`,
                backgroundColor: hovered ? "#fafafa" : "#ffffff",
                transition: "background-color 0.15s",
            }}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={onCheck}
                style={{
                    width: "16px", height: "16px",
                    accentColor: "#4338ca", cursor: "pointer", flexShrink: 0,
                }}
            />

            <div style={{
                width: "44px", height: "44px",
                borderRadius: "8px",
                backgroundColor: greyishBlue50,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "11px", fontWeight: "600", color: "#9ca3af",
                flexShrink: 0,
            }}>
                IMG
            </div>

            <div style={{flex: 1, minWidth: 0}}>
                <div style={{fontSize: "12px", color: "#9ca3af", marginBottom: "2px"}}>{row.sku}</div>
                <div style={{fontSize: "15px", fontWeight: "700", color: "#111827"}}>{row.label}</div>
            </div>

            <OptionValueSelect
                value={row.optionValue}
                onChange={(val) => onOptionValueChange(row.id, val)}
            />

            <div style={{
                fontSize: "13px", fontWeight: "500",
                color: "#9ca3af", minWidth: "40px", textAlign: "center",
            }}>
                {row.lang || "—"}
            </div>

            <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                <button
                    onClick={() => onValidate(row.id)}
                    style={{background: "none", border: "none", cursor: "pointer", padding: "2px", display: "flex"}}
                >
                    <CheckIcon/>
                </button>
                <button
                    onClick={() => onEdit(row.id)}
                    style={{background: "none", border: "none", cursor: "pointer", padding: "2px", display: "flex"}}
                    onMouseEnter={e => e.currentTarget.style.opacity = "0.6"}
                    onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                >
                    <PenIcon/>
                </button>
            </div>
        </div>
    );
}

export default MappingValueLine;
